var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M7.43055 6.04635C7.39351 5.84226 7.21488 5.68749 7.0001 5.68749C6.75848 5.68749 6.5626 5.88337 6.5626 6.12499V10.0644L6.56965 10.143C6.60669 10.3471 6.78532 10.5019 7.0001 10.5019C7.24172 10.5019 7.4376 10.306 7.4376 10.0644V6.12499L7.43055 6.04635ZM7.69897 4.15624C7.69897 3.79381 7.40516 3.49999 7.04272 3.49999C6.68029 3.49999 6.38647 3.79381 6.38647 4.15624C6.38647 4.51868 6.68029 4.81249 7.04272 4.81249C7.40516 4.81249 7.69897 4.51868 7.69897 4.15624ZM14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7ZM0.875 7C0.875 3.61726 3.61726 0.875 7 0.875C10.3827 0.875 13.125 3.61726 13.125 7C13.125 10.3827 10.3827 13.125 7 13.125C3.61726 13.125 0.875 10.3827 0.875 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.724a2d5143f7e315fa49dd04bad350d2.svg";
export { ForwardRef as ReactComponent };